export default {
  "content": "<g clip-path=\"url(#clip0_574_91468)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 16.5a8 8 0 100-16 8 8 0 000 16zm.068-6.576H7.284v-.24c-.096-.924.132-1.524 1.128-1.932l.432-.168c.432-.18.624-.528.624-.852 0-.588-.408-.912-.972-.912-.516 0-1.02.384-1.032 1.044H6C6 5.22 7.092 4.32 8.508 4.32c1.428 0 2.472.9 2.472 2.34 0 1.164-.696 1.944-1.62 2.268-.456.156-.78.276-.78.768l-.012.228zm.372 1.908c0 .564-.468.972-1.02.972-.54 0-.996-.408-.996-.972 0-.564.456-.96.996-.96.552 0 1.02.396 1.02.96z\" fill=\"#8A8F9E\"/></g><defs><clipPath id=\"clip0_574_91468\"><path fill=\"#fff\" transform=\"translate(.5 .5)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "17",
    "height": "17",
    "viewBox": "0 0 17 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};